module.exports = __webpack_public_path__ + "img/Gallery_2_07.4b751ddf.jpeg";